import { useRouter } from "@tanstack/react-router";
import { IconMailPlus, IconUserPlus } from "@tabler/icons-react";
import { useAtom } from "jotai";
import { Button } from "@/components/ui/button";
import { usersDialogAtom } from "../store/users-atom";

export function UsersPrimaryButtons() {
  const router = useRouter();
  const [, setOpen] = useAtom(usersDialogAtom);

  return (
    <div className="flex gap-2">
      <Button
        variant="outline"
        className="space-x-1"
        onClick={() => setOpen("invite")}
      >
        <span>Invite User</span> <IconMailPlus size={18} />
      </Button>
      <Button
        className="space-x-1"
        onClick={() => {
          void router.navigate({ to: "/users/create-user" });
        }}
      >
        <span>Add User</span> <IconUserPlus size={18} />
      </Button>
    </div>
  );
}
